module.exports = __webpack_public_path__ + "static/submit-7c68c8b3747eab29b14a259ee80ed25d.png";